export enum NodeType {
  CIRCLE = 'circle',
  SQUARE = 'square',
  DIAMOND = 'diamond',
  INPUT_NODE = 'inputNode',
  LABEL_NODE = 'labelNode',
  OUTPUT_NODE = 'outputNode',
}

export enum EdgeType {
  SOLID_LINE = 'solidLine',
  DASHED_LINE = 'dashedLine',
}
